<template>
  <div>
    <h6>
      {{ question.label }} {{ question.required ? '*' : '' }}
      <small v-if="isLockable" class="text-muted">
        <i class="fa fa-fw fa-lock"></i>
      </small>
      <small v-if="isEditable">
        <b-button v-if="isEditable" variant="link" size="sm" class="text-danger py-0" @click="editing = !editing">
          {{ trans(!editing ? 'edit' : 'save') }}
        </b-button>
      </small>
      <small v-if="isCollapsible" class="ml-2">
        <b-form-checkbox v-model="expand" size="sm" class="d-inline" :disabled="cannotCollapse">
          {{ question.options.expand_label || trans('show') }}
        </b-form-checkbox>
      </small>
    </h6>
    <div :class="isCollapsible && !cannotCollapse && !expand ? 'd-none' : ''">
      <div class="mb-2" v-html="question.description"></div>
      <b-form-group>
        <div
          v-if="question.options.show_select_all || question.options.show_select_all !== false && checkbox_options.length >= 5"
          class="mb-1">
          <b-button variant="link" size="sm" class="text-branded p-0" @click="onSelectOrClearAll(true)">
            {{ trans('select_all') }}
          </b-button>
          <b-button variant="link" size="sm" class="text-branded p-0 ml-2" @click="onSelectOrClearAll(false)">
            {{ trans('unselect_all') }}
          </b-button>
        </div>
        <b-form-checkbox-group
          :size="size"
          :name="question.slug"
          v-model="checked"
          :stacked="!question.options.inline || !!question.options.description"
          :state="!!errors ? false : null"
          @change="$emit('clear-error', question.slug)"
        >
          <b-form-checkbox
            v-for="(o, index) in checkbox_options"
            :key="index"
            :value="o.value"
            :readonly="isLocked"
            :disabled="isLocked"
          >
            {{ o.value }}
            <div v-if="o.description" v-html="o.description"></div>
          </b-form-checkbox>
        </b-form-checkbox-group>
        <div v-if="question.options.other_option">
          <label class="mb-0">
            {{ question.options.other_label || trans('other') }}
          </label>
          <b-form-input
            v-model="other"
            :state="!!errors ? false : null"
            @change="$emit('clear-error', question.slug)"
          ></b-form-input>
        </div>
        <b-form-invalid-feedback :state="!!errors ? false : null">
          {{ (errors || []).join(' ') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </div>
  </div>
</template>

<script>
function extractCheckedValues(question, checked) {
  return _.reduce(checked || [], (checked, value) => {
    if ((question.options.values || []).indexOf(value) >= 0) {
      checked.push(value)
    }
    return checked
  }, [])
}

function extractOtherValue(question, checked) {
  return _.reduce(checked || [], (others, value) => {
    if ((question.options.values || []).indexOf(value) === -1) {
      others.push(value)
    }
    return others
  }, []).join(',')
}

export default {
  props: {
    organization: Object,
    value: Array, // checked
    question: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    errors: Array,
  },
  data() {
    return {
      trans: trans,
      checked: extractCheckedValues(this.question, this.value ?? this.question.options.checked_values),
      other: extractOtherValue(this.question, this.value),
      editing: false,
      expand: false,
    }
  },
  computed: {
    checkbox_options() {
      let descriptions = this.question.options.descriptions || null
      return (this.question.options.values || []).map((value, i) => {
        return {
          value: value,
          description: descriptions ? descriptions[i] : null
        }
      })
    },
    combined() {
      let combined = _.clone(this.checked)
      if (this.other) combined.push(this.other)
      return combined
    },
    isLocked() {
      if (this.question.options.locked && (!this.organization || !this.organization.auth_user)) return true
      return this.question.options.locked && !this.editing
    },
    isLockable() {
      return this.question.options.locked
    },
    isEditable() {
      return this.question.options.locked && !!this.organization && !!this.organization.auth_user
    },
    isCollapsible() {
      return !this.question.required && !this.question.options.locked && this.question.options.collapsible
    },
    cannotCollapse() {
      return !_.isEmpty(this.combined)
    },
  },
  watch: {
    checked() {
      if (!_.isEqual(this.value, this.combined)) {
        this.$emit('input', this.combined)
      }
    },
    other() {
      if (!_.isEqual(this.value, this.combined))
        this.$emit('input', this.combined)
    },
    value() {
      this.checked = extractCheckedValues(this.question, this.value)
      this.other = extractOtherValue(this.question, this.value)
    },
    combined() {
      if (!_.isEmpty(this.combined) && !this.expand) this.expand = true
    },
    question(newValue) {
      this.checked = extractCheckedValues(this.question, newValue.options.checked_values)
      this.other = extractOtherValue(this.question, newValue.options.checked_values)
    }
  },
  methods: {
    onSelectOrClearAll(check) {
      if (!check) {
        this.checked = []
      } else {
        this.checked = _.map(this.checkbox_options, 'value')
      }
    },
  },
  mounted() {
    window['formCheckboxQuestion' + (this.question.id || '')] = this
    this.$nextTick(() => {
      if (!_.isEmpty(this.combined) && !this.expand) this.expand = true
    })
  },
}
</script>
